import api from './api';

const documentoService = {
  obtenerCatalogos: async () => {
  try {
    const response = await api.get('/catalogos');
    return response.data;
  } catch (error) {
    console.error('Error al obtener catálogos:', error);
    throw error;
  }
},

  obtenerUsuarios: async () => {
  try {
    const response = await api.get('/usuarios');
    return response.data;
  } catch (error) {
    console.error('Error al obtener usuarios:', error);
    throw error;
  }
},
  // Crear documento con archivos
  crearDocumento: async (formData) => {
    try {
      const response = await api.post('/documentos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al crear documento' };
    }
  },

  // Obtener documentos con filtros y paginación
  obtenerDocumentos: async (filtros = {}) => {
    try {
      const params = new URLSearchParams();
      
      // Paginación
      if (filtros.page) params.append('page', filtros.page);
      if (filtros.limit) params.append('limit', filtros.limit);
      
      // Filtros
      if (filtros.estado) params.append('estado', filtros.estado);
      if (filtros.tipoRegistro) params.append('tipoRegistro', filtros.tipoRegistro);
      if (filtros.fechaInicio) params.append('fechaInicio', filtros.fechaInicio);
      if (filtros.fechaFin) params.append('fechaFin', filtros.fechaFin);
      if (filtros.local) params.append('local', filtros.local);
      if (filtros.centroCosto) params.append('centroCosto', filtros.centroCosto);
      if (filtros.grupo) params.append('grupoId', filtros.grupo);
      if (filtros.usuario) params.append('usuario', filtros.usuario);
      if (filtros.tipoDoc) params.append('tipoDoc', filtros.tipoDoc);
      if (filtros.numDoc) params.append('numDoc', filtros.numDoc);
      if (filtros.glosa) params.append('glosa', filtros.glosa);
      if (filtros.motivo) params.append('motivo', filtros.motivo);

      // Ordenamiento por columna
      if (filtros.orderBy) params.append('orderBy', filtros.orderBy);
      if (filtros.orderDir) params.append('orderDir', filtros.orderDir);

      const response = await api.get(`/documentos?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al obtener documentos' };
    }
  },

  // Obtener documento por ID
  obtenerDocumentoPorId: async (id) => {
    try {
      const response = await api.get(`/documentos/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al obtener documento' };
    }
  },

  // Anular documento
  anularDocumento: async (id, motivo) => {
    try {
      const response = await api.put(`/documentos/${id}/anular`, { motivo });
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al anular documento' };
    }
  },

  // Obtener totales
  obtenerTotales: async (filtros = {}) => {
    try {
      const params = new URLSearchParams();

      if (filtros.fechaInicio) params.append('fechaInicio', filtros.fechaInicio);
      if (filtros.fechaFin) params.append('fechaFin', filtros.fechaFin);
      if (filtros.local) params.append('local', filtros.local);
      if (filtros.grupo) params.append('grupoId', filtros.grupo);
      if (filtros.usuario) params.append('usuario', filtros.usuario);
      if (filtros.tipoRegistro) params.append('tipoRegistro', filtros.tipoRegistro);
      if (filtros.estado) params.append('estado', filtros.estado);
      if (filtros.motivo) params.append('motivo', filtros.motivo);
      if (filtros.tipoDoc) params.append('tipoDoc', filtros.tipoDoc);
      if (filtros.numDoc) params.append('numDoc', filtros.numDoc);
      if (filtros.glosa) params.append('glosa', filtros.glosa);

      const response = await api.get(`/documentos/totales?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al calcular totales' };
    }
  },

  // Obtener URL de imagen
  // Las imágenes se sirven desde el mismo backend Node (ruta protegida por
  // authMiddleware), que solo es alcanzable a través del prefijo /apiv2 en
  // producción (el backend vive fuera de public_html, no hay forma de
  // llegar a él directamente por otra ruta). Por eso se arma la URL sobre
  // REACT_APP_API_URL completo, sin quitarle el prefijo.
  getImagenUrl: (ruta) => {
    if (!ruta) return null;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/apiv2';
    return `${baseUrl}${ruta}`;
  },
  editarDocumento: async (id, formData) => {
    try {
      const response = await api.put(`/documentos/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al editar documento:', error);
      
      // Si el error es de permisos, lanzar mensaje específico
      if (error.response?.status === 403) {
        throw new Error('No tienes permisos para editar documentos. Se requiere nivel Tesorero.');
      }
      
      // Si el error es de validación
      if (error.response?.status === 400) {
        const mensaje = error.response?.data?.message || 'Error de validación';
        throw new Error(mensaje);
      }
      
      throw error;
    }
  },
  obtenerInformes: async () => {
    try {
      const response = await api.get('/documentos/informes');
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Error al obtener datos de informes' };
    }
  },

  eliminarImagenDocumento: async (documentoId, imagenId) => {
    try {
      const response = await api.delete(`/documentos/${documentoId}/imagenes/${imagenId}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar imagen:', error);
      
      if (error.response?.status === 403) {
        throw new Error('No tienes permisos para eliminar imágenes. Se requiere nivel Tesorero.');
      }
      
      throw error;
    }
  }
  

  
};


export default documentoService;